// extracted by mini-css-extract-plugin
export var bodyRow = "_gd-d";
export var cardColumns = "_gd-e";
export var ellipsesOverflow = "_gd-2";
export var flatBottomCorners = "_gd-3";
export var flatTopCorners = "_gd-4";
export var headerActionsDropdown = "_gd-f";
export var headerBottomRow = "_gd-c";
export var headerTopRow = "_gd-b";
export var orderDetailsWrapper = "_gd-0";
export var orderInfoContainer = "_gd-1";
export var productDetails = "_gd-9";
export var productImage = "_gd-5";
export var responsiveTable = "_gd-8";
export var shipmentContainer = "_gd-a";
export var tableBottomLeft = "_gd-6";
export var tableBottomRight = "_gd-7";
export var trackingLink = "_gd-g";